import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "g-row g-row--appearance_spaced" }
const _hoisted_2 = { class: "g-cell g-cols g-cols--12 relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_address_input = _resolveComponent("address-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_address_input, {
        appearance: ["bordered"],
        placeholder: $props.placeholder,
        value: $setup.autocomplete,
        rules: $props.rules,
        onCallback: $setup.setLocationFromAutocomplete
      }, null, 8, ["placeholder", "value", "rules"]),
      _renderSlot(_ctx.$slots, "error")
    ])
  ]))
}